import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.order-planning-configuration')
  .factory('OrdersPlanningMonitorAPI', OrdersPlanningMonitorAPI);

function OrdersPlanningMonitorAPI(): BringozApi {
  return {
    base: `/importers-daily-orders-planning/monitor`,
    infiniteScroll: {
      address: `/importers-daily-orders-planning/monitor`,
      cmd: 'GET'
    },
    actions : {
    }
  }
}
